(function () {
  var SG_INSTANCE = 0; // document-unique id prefix per hydrated root (a11y aria-controls)
  function initSizeGuide(root) {
    if (!root || root.dataset.sgHydrated) return;
    root.dataset.sgHydrated = '1';
    var instanceId = 'sg' + ++SG_INSTANCE;

    var dataEl = root.querySelector('[data-sg-data]');
    var CONFIG = {};
    try {
      CONFIG = JSON.parse((root.querySelector('[data-sg-config]') || {}).textContent || '{}') || {};
    } catch (e) {
      CONFIG = {};
    }
    var SHAPES = [];
    try {
      SHAPES = JSON.parse(dataEl.textContent) || [];
    } catch (e) {
      SHAPES = [];
    }
    // Parse each shape's size_chart string once; derive which measures it asks.
    var ORDER = ['XS', 'S', 'M', 'L', 'XL', '2X', '3X', '4X', '5X'];
    var MEASURE_KEYS = ['chest', 'waist', 'hips'];
    SHAPES.forEach(function (s) {
      try {
        s.chart = JSON.parse(s.sizeChart) || {};
      } catch (e) {
        s.chart = {};
      }
      try {
        s.garment = JSON.parse(s.garmentChart) || { columns: [], rows: {} };
      } catch (e) {
        s.garment = { columns: [], rows: {} };
      }
      s.sizes = Object.keys(s.chart);
      var first = s.chart[s.sizes[0]] || {};
      s.asks = MEASURE_KEYS.filter(function (k) {
        return first[k] != null && first[k] !== '';
      });
    });

    var MEAS = {
      chest: {
        label: 'Chest',
        q: "What's your chest?",
        help: 'Tape around the fullest part, level all the way round.',
        min: 30,
        max: 64,
      },
      waist: {
        label: 'Waist',
        q: "What's your waist?",
        help: 'The narrowest part of your torso — keep the tape snug, not tight.',
        min: 24,
        max: 58,
      },
      hips: {
        label: 'Hip',
        q: 'What are your hips?',
        help: 'Feet together, tape around the fullest part.',
        min: 33,
        max: 70,
      },
    };
    var FRACTIONS = { 0: 0, 0.5: 0.5, 1: 1 };
    var CM = 2.54;

    // Garment-chart column keys -> display label (single source for chart + measure).
    var COL_LABEL = {
      chest: 'Chest',
      waist: 'Waist',
      waistStretched: 'Waist (stretched)',
      hips: 'Hip',
      hipsStretched: 'Hip (stretched)',
      frontLength: 'Front length',
      backLength: 'Back length',
      length: 'Length',
      sleeveLength: 'Sleeve length',
      sleeveOpen: 'Sleeve opening',
      shoulderToWaist: 'Shoulder to waist seam',
      armWidth: 'Arm width',
      inseam: 'Inseam',
      outseam: 'Outseam',
      legOpen: 'Leg opening',
      fullHem: 'Full hem',
      hem: 'Hem',
      frontRise: 'Front rise',
      backRise: 'Back rise',
      scoopNeckWidth: 'Scoop neck width',
      scoopNeckDrop: 'Scoop neck drop',
      vNeckWidth: 'V-neck width',
      vNeckDrop: 'V-neck drop',
    };
    // Body measurements a shopper can take on themselves -> "how to measure" copy.
    // A column not listed here is a garment-construction dimension: it shows in the
    // size chart (step 4) but not in the Measure Yourself accordion.
    var HOW = {
      chest:
        'Wrap the tape around the fullest part of your chest, keeping it level all the way around and your arms relaxed.',
      waist: 'The narrowest part of your torso — usually just above the belly button, where you bend side to side.',
      hips: 'Stand with feet together and measure around the fullest part, roughly 8 in below your natural waist.',
      frontLength: 'From the highest point of the shoulder straight down the front to where you want the hem to sit.',
      backLength: 'From the bone at the base of your neck straight down your spine to your preferred hem.',
      length:
        'From the highest point of the shoulder (or your waist, for skirts and pants) straight down to where you want the hem to fall.',
      sleeveLength:
        'From the top of the shoulder down the outside of a relaxed arm to where you want the sleeve to end.',
      shoulderToWaist:
        'From the top of the shoulder down to your natural waist — this tells you where the waist seam will land.',
      armWidth: 'Around the widest part of your upper arm, with the arm relaxed at your side.',
      inseam: 'From the crotch seam straight down the inside of the leg to the ankle.',
      outseam: 'From the top of your waistband down the outside of the leg to the hem.',
    };
    // Short, uniform size labels for the big result number + Shop button.
    // (size_chart "display" is long for XS-XL — "Extra Large" etc. — which
    // overflows the 74px numeral, so derive a compact label from the code.)
    var SHORT_SIZE = { XS: 'XS', S: 'S', M: 'M', L: 'L', XL: 'XL', '2X': '2XL', '3X': '3XL', '4X': '4XL', '5X': '5XL' };
    function shortSize(code, display) {
      return SHORT_SIZE[code] || display || code;
    }

    // Runtime-only sync events (no persistence) so sibling v2 sections on the
    // same page can react to unit/shape changes. State is in-memory and resets
    // on refresh — with one page there's no cross-page hand-off to preserve.
    var UNIT_EVENT = 'dress-calc-unit-changed';
    var SHAPE_EVENT = 'dress-calc-shape-changed';

    // ---- state ----
    var state = {
      shapeIndex: 0,
      unit: 'in',
      fit: 0.5,
      values: {}, // key -> inches
      entered: {}, // key -> true
      step: 'shape', // 'shape' | measure index int
      done: false,
    };
    // deep-link ?shape=
    try {
      var qs = new URLSearchParams(window.location.search);
      var want = qs.get('shape');
      if (want) {
        var idx = SHAPES.findIndex(function (s) {
          return s.key === want;
        });
        if (idx >= 0) state.shapeIndex = idx;
      }
    } catch (e) {}

    // The fallback must carry every field the renderers read. `garment` especially:
    // renderMeasureYourself reads sh.garment.columns, and with no shape blocks (or an
    // unparseable data island) a missing one throws. By then data-sg-hydrated is set,
    // so the spinner is gone and the guide would sit blank with no error shown.
    function shape() {
      return (
        SHAPES[state.shapeIndex] || {
          name: '',
          key: '',
          descriptor: '',
          image: '',
          diagram: '',
          asks: [],
          chart: {},
          sizes: [],
          garment: { columns: [], rows: {} },
          gallery: {},
          galleryCaptions: {},
        }
      );
    }

    // ---- refs ----
    var $ = function (sel) {
      return root.querySelector(sel);
    };
    var steps = {
      shape: $('[data-sg-step="shape"]'),
      measure: $('[data-sg-step="measure"]'),
    };
    var progressEl = $('[data-sg-progress]');
    var shapeTrack = $('[data-sg-shape-track]');
    var switchEl = $('[data-sg-switch]');
    var switchChips = $('[data-sg-switch-chips]');
    var switchMySize = $('[data-sg-switch-mysize]');
    var switchSizeEl = $('[data-sg-switch-size]');
    var measureEl = $('[data-sg-measure]');
    var measureFigure = $('[data-sg-measure-figure]');
    var measureIntro = $('[data-sg-measure-intro]');
    var measureNote = $('[data-sg-measure-note]');
    var accEl = $('[data-sg-acc]');
    var chartEl = $('[data-sg-chart]');
    var chartTitle = $('[data-sg-chart-title]');
    var chartBanner = $('[data-sg-chart-banner]');
    var chartTable = $('[data-sg-chart-table]');
    var galleryEl = $('[data-sg-gallery]');
    var galleryIntro = $('[data-sg-gallery-intro]');
    var gallerySizes = $('[data-sg-gallery-sizes]');
    var galleryShop = $('[data-sg-gallery-shop]');
    var galleryReset = $('[data-sg-gallery-reset]');
    var galleryKicker = $('[data-sg-gallery-kicker]');
    var galleryFigure = $('[data-sg-gallery-figure]');
    var galleryDots = $('[data-sg-gallery-dots]');
    var galleryPrev = $('[data-sg-gallery-arrow="-1"]');
    var galleryNext = $('[data-sg-gallery-arrow="1"]');
    var galleryCaption = $('[data-sg-gallery-caption]');
    // NOTE: don't use Liquid `default:` with a double-quoted string that contains an
    // escaped " — Liquid can't parse it (sync error). Rely on the schema default, with
    // a JS fallback (where \" is valid) for the cleared-setting case.
    var GALLERY_CAPTION = CONFIG.galleryCaption || 'Model is 5\'7"';
    var MEASURE_INTRO =
      CONFIG.measureIntro || 'Use a soft measuring tape over bare skin or close-fitting clothes — snug, not tight.';
    var MEASURE_NOTE =
      CONFIG.measureNote || 'Compare your numbers to the garment chart below — or let the calculator do it.';

    // ---- rounding / unit helpers ----
    function toDisplay(inches) {
      return state.unit === 'cm' ? Math.round(inches * CM) : Math.round(inches);
    }
    function fromDisplay(v) {
      return state.unit === 'cm' ? v / CM : v;
    }

    // ---- size calculation (relaxed+stretched interpolation, XS->5X first fit) ----
    function threshold(row, key) {
      var relaxed = Number(row[key]);
      if (isNaN(relaxed)) return null;
      var st = row[key + '_stretched'];
      if (st === undefined || st === null || st === '') return relaxed;
      var s = Number(st);
      return isNaN(s) ? relaxed : relaxed + (s - relaxed) * state.fit;
    }
    // Midpoint of a measurement's relaxed↔stretched range. Used for the displayed "room"
    // number, which must be a fixed property of (size, body) — NOT the fit-dial threshold,
    // or the same size would report different room at different fit settings.
    function midThreshold(row, key) {
      var relaxed = Number(row[key]);
      if (isNaN(relaxed)) return null;
      var st = row[key + '_stretched'];
      if (st === undefined || st === null || st === '') return relaxed;
      var s = Number(st);
      return isNaN(s) ? relaxed : (relaxed + s) / 2;
    }
    function recommend() {
      var sh = shape();
      var asks = sh.asks;
      for (var i = 0; i < sh.sizes.length; i++) {
        var code = sh.sizes[i];
        var row = sh.chart[code];
        var ok = true,
          tightest = null,
          tightestSlack = Infinity;
        for (var a = 0; a < asks.length; a++) {
          var key = asks[a];
          var t = threshold(row, key);
          var v = state.values[key];
          if (t == null || v == null) {
            ok = false;
            break;
          }
          if (v > t) {
            ok = false;
            break;
          }
          var slack = t - v;
          if (slack < tightestSlack) {
            tightestSlack = slack;
            tightest = key;
          }
        }
        if (ok) {
          // "room" for display is measured from the MIDPOINT of each measurement's stretch
          // range — a fixed property of (size, body), independent of the fit dial (whose job
          // is to pick the size). Report the tightest such gap. May be negative for a snug pick.
          var roomKey = null,
            roomSlack = Infinity;
          for (var b = 0; b < asks.length; b++) {
            var mk = asks[b];
            var mid = midThreshold(row, mk);
            if (mid == null) continue;
            var rs = mid - state.values[mk];
            if (rs < roomSlack) {
              roomSlack = rs;
              roomKey = mk;
            }
          }
          return { code: code, row: row, tightest: roomKey, slack: roomSlack };
        }
      }
      return null; // above 5X -> contact us path
    }

    // ---- render: shape carousel ----
    function renderShapes() {
      shapeTrack.innerHTML = '';
      SHAPES.forEach(function (s, i) {
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'sg-shape-card';
        card.setAttribute('data-sg-shape', i);
        card.setAttribute('aria-pressed', i === state.shapeIndex ? 'true' : 'false');
        var photo = s.image
          ? '<div class="sg-shape-photo"><img src="' + s.image + '" alt="' + s.name + '"></div>'
          : '<div class="sg-shape-photo">' + s.name + ' photo</div>';
        card.innerHTML = photo + '<div class="sg-shape-meta"><div class="sg-shape-name">' + s.name + '</div></div>';
        card.addEventListener('click', function () {
          pickShape(i);
        });
        shapeTrack.appendChild(card);
      });
    }

    function pickShape(i) {
      state.shapeIndex = i;
      Array.prototype.forEach.call(shapeTrack.children, function (c, idx) {
        c.setAttribute('aria-pressed', idx === i ? 'true' : 'false');
      });
      try {
        window.dispatchEvent(new CustomEvent(SHAPE_EVENT, { detail: { key: shape().key, index: i } }));
      } catch (e) {}
      renderSwitcher();
      accOpen = undefined; // new shape -> default its first measurement open
      gallerySize = null; // new shape -> gallery follows the recommended size again
      renderMeasureYourself();
      renderChart();
      renderGallery();
      // if all this shape's measurements known -> straight to result
      var missing = shape().asks.filter(function (k) {
        return !state.entered[k];
      });
      if (missing.length === 0) {
        goResult();
      } else {
        goMeasure(0);
      }
    }

    // ---- render: measurement step ----
    var mIdx = 0;
    function currentKey() {
      return shape().asks[mIdx];
    }
    function renderMeasure() {
      var key = currentKey();
      var meta = MEAS[key];
      var total = shape().asks.length + 1; // +1 for shape step
      $('[data-sg-m-eyebrow]').textContent = 'Step ' + (mIdx + 2) + ' of ' + total;
      $('[data-sg-m-q]').textContent = meta.q;
      $('[data-sg-m-help]').innerHTML = meta.help + ' <a href="#" data-sg-see-measure>See how to measure &darr;</a>';
      var val = state.values[key];
      if (val == null) val = Math.round((meta.min + meta.max) / 2);
      state.values[key] = val;
      // ticks background (one tick per inch, drawn as repeating gradient)
      var span = meta.max - meta.min;
      var ticks = $('[data-sg-ticks]');
      ticks.style.background = 'linear-gradient(90deg,' + '#b9c8ce 0 1.5px, transparent 1.5px 100%)';
      ticks.style.backgroundSize = 100 / span + '% 100%';
      var range = $('[data-sg-range]');
      range.min = meta.min;
      range.max = meta.max;
      range.step = 1;
      range.value = val;
      paintRange();
      $('[data-sg-min]').textContent = toDisplay(meta.min) + (state.unit === 'cm' ? '' : '"');
      $('[data-sg-max]').textContent = toDisplay(meta.max) + (state.unit === 'cm' ? '' : '"');
      $('[data-sg-input-unit]').textContent = state.unit;
      paintInput();
      $('[data-sg-next]').textContent = mIdx === shape().asks.length - 1 ? 'See my size →' : 'Next';
      $('[data-sg-back]').textContent = mIdx === 0 ? 'Back' : 'Back';
    }
    function paintInput() {
      $('[data-sg-input]').value = toDisplay(state.values[currentKey()]);
    }
    function paintRange() {
      var range = $('[data-sg-range]');
      var meta = MEAS[currentKey()];
      var pct = ((state.values[currentKey()] - meta.min) / (meta.max - meta.min)) * 100;
      range.style.background =
        'linear-gradient(90deg, var(--sg-accent) 0 ' + pct + '%, var(--sg-track) ' + pct + '% 100%)';
    }
    // skipInputPaint: leave the number field alone while the shopper is typing in it.
    // Rewriting it mid-entry would fight them for the caret.
    function setValueInches(inches, skipInputPaint) {
      var key = currentKey();
      var meta = MEAS[key];
      inches = Math.max(meta.min, Math.min(meta.max, Math.round(inches)));
      state.values[key] = inches;
      $('[data-sg-range]').value = inches;
      paintRange();
      if (!skipInputPaint) paintInput();
    }

    // ---- navigation ----
    function setStepClass() {
      root.classList.toggle('is-measuring', typeof state.step === 'number');
      root.classList.toggle('is-done', state.done);
      steps.shape.classList.toggle('is-active', state.step === 'shape' && !state.done);
      steps.measure.classList.toggle('is-active', typeof state.step === 'number' && !state.done);
      renderProgress();
    }
    function goShape() {
      state.done = false;
      state.step = 'shape';
      setStepClass();
    }
    function goMeasure(i) {
      state.done = false;
      mIdx = i;
      state.step = i;
      renderMeasure();
      setStepClass();
    }
    function goResult() {
      // require all asks entered
      var missing = shape().asks.filter(function (k) {
        return state.values[k] == null;
      });
      if (missing.length) {
        goMeasure(shape().asks.indexOf(missing[0]));
        return;
      }
      shape().asks.forEach(function (k) {
        state.entered[k] = true;
      });
      state.done = true;
      state.step = 'done';
      renderResult();
      setStepClass();
      // move focus into the result so screen-reader / keyboard users land on the
      // recommendation instead of the now-hidden "See my size" button.
      // preventScroll: switching shapes from the pinned switcher lower down the page
      // must not yank the viewport up to the result panel.
      var resultLeft = root.querySelector('.sg-result-left');
      if (resultLeft) resultLeft.focus({ preventScroll: true });
    }

    function renderProgress() {
      var total = shape().asks.length + 1;
      var done = state.done ? total : state.step === 'shape' ? 1 : state.step + 1 + 1;
      progressEl.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var b = document.createElement('span');
        if (i < done) b.className = 'is-on';
        progressEl.appendChild(b);
      }
    }

    // ---- render: page-level shape switcher ----
    function renderSwitcher() {
      if (!switchEl) return;
      if (SHAPES.length < 2) {
        switchEl.hidden = true;
        return;
      }
      switchEl.hidden = false;
      // build the chips once, then only sync pressed state
      if (!switchChips.children.length) {
        SHAPES.forEach(function (s, i) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'button button--chip button--sm button--compact sg-switch-chip';
          chip.textContent = s.name;
          chip.addEventListener('click', function () {
            pickShape(i);
          });
          switchChips.appendChild(chip);
        });
      }
      Array.prototype.forEach.call(switchChips.children, function (c, i) {
        c.setAttribute('aria-pressed', i === state.shapeIndex ? 'true' : 'false');
      });
      // "Your size" — only once every measurement this shape needs is confirmed
      var sh = shape();
      var ready =
        sh.asks.length > 0 &&
        sh.asks.every(function (k) {
          return state.entered[k];
        });
      var rec = ready ? recommend() : null;
      if (rec) {
        switchMySize.hidden = false;
        switchSizeEl.textContent = shortSize(rec.code, rec.row.display);
      } else {
        switchMySize.hidden = true;
      }
    }

    // ---- render: Measure Yourself (shape-driven accordion + diagram) ----
    // open accordion row: undefined = default to first; null = all closed; string = that key
    var accOpen;
    function renderMeasureYourself() {
      if (!measureEl) return;
      var sh = shape();
      // body-measurable columns for this shape = chart columns that have how-to copy
      var cols = (sh.garment.columns || []).filter(function (k) {
        return HOW[k];
      });
      if (!cols.length) {
        measureEl.hidden = true;
        return;
      }
      measureEl.hidden = false;

      if (sh.diagram) {
        measureFigure.classList.remove('is-empty');
        measureFigure.innerHTML = '<img src="' + sh.diagram + '" alt="' + sh.name + ' measuring guide">';
      } else {
        measureFigure.classList.add('is-empty');
        measureFigure.textContent = sh.name + ' measuring guide';
      }

      measureIntro.textContent = MEASURE_INTRO;
      measureNote.innerHTML = '<strong>Please note:</strong> ' + MEASURE_NOTE;

      if (accOpen === undefined || (accOpen !== null && cols.indexOf(accOpen) === -1)) {
        accOpen = cols[0];
      }

      accEl.innerHTML = '';
      cols.forEach(function (key) {
        var item = document.createElement('div');
        item.className = 'sg-acc-item';
        var isOpen = key === accOpen;
        var usesCalc = sh.asks.indexOf(key) > -1;
        var badge = usesCalc ? '<span class="sg-acc-badge">Calculator uses this</span>' : '';
        var panelId = instanceId + '-acc-' + key;
        item.innerHTML =
          '<button type="button" class="sg-acc-head" aria-expanded="' +
          (isOpen ? 'true' : 'false') +
          '" aria-controls="' +
          panelId +
          '"><span class="sg-acc-label">' +
          (COL_LABEL[key] || key) +
          '</span>' +
          badge +
          '<span class="sg-acc-chev" aria-hidden="true">⌄</span></button>' +
          '<p class="sg-acc-panel" id="' +
          panelId +
          '"' +
          (isOpen ? '' : ' hidden') +
          '>' +
          HOW[key] +
          '</p>';
        item.querySelector('.sg-acc-head').addEventListener('click', function () {
          accOpen = accOpen === key ? null : key;
          renderMeasureYourself();
        });
        accEl.appendChild(item);
      });
    }

    // Jump from a wizard step's "See how to measure" link to that measurement's
    // row in the Measure Yourself card.
    function openMeasureFor(key) {
      if (!measureEl || measureEl.hidden) return;
      accOpen = key;
      renderMeasureYourself();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      measureEl.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    // ---- render: garment size chart ----
    function fmtChart(v) {
      if (v == null) return '—';
      return state.unit === 'cm' ? Math.round(v * CM * 10) / 10 + 'cm' : v + 'in';
    }
    function renderChart() {
      if (!chartEl) return;
      var sh = shape();
      var cols = sh.garment.columns || [];
      var rowKeys = Object.keys(sh.garment.rows || {});
      if (!cols.length || !rowKeys.length) {
        chartEl.hidden = true;
        return;
      }
      chartEl.hidden = false;
      chartTitle.textContent = sh.name + ' size chart';

      // recommended row — only once customer has completed a calculator flow
      var ready =
        sh.asks.length > 0 &&
        sh.asks.every(function (k) {
          return state.entered[k];
        });
      var rec = ready ? recommend() : null;
      var recKey = rec ? SHORT_SIZE[rec.code] || rec.code : null;
      if (rec) {
        chartBanner.hidden = false;
        chartBanner.innerHTML = 'Your recommended row, <strong>' + recKey + '</strong>, is highlighted below.';
      } else {
        chartBanner.hidden = true;
      }

      var head = '<thead><tr><th scope="col" class="sg-chart-th sg-chart-sticky">US size</th>';
      cols.forEach(function (k) {
        head += '<th scope="col" class="sg-chart-th">' + (COL_LABEL[k] || k) + '</th>';
      });
      head += '</tr></thead>';

      var body = '<tbody>';
      rowKeys.forEach(function (code) {
        var row = sh.garment.rows[code] || {};
        body += '<tr class="sg-chart-tr' + (code === recKey ? ' is-rec' : '') + '">';
        body += '<th scope="row" class="sg-chart-td sg-chart-sticky sg-chart-sizecell">' + code + '</th>';
        cols.forEach(function (k) {
          body += '<td class="sg-chart-td">' + fmtChart(row[k]) + '</td>';
        });
        body += '</tr>';
      });
      body += '</tbody>';
      chartTable.innerHTML = head + body;
    }

    // ---- render: gallery ----
    var gallerySize = null;
    function galleryRecommended() {
      var sh = shape();
      var ready =
        sh.asks.length > 0 &&
        sh.asks.every(function (k) {
          return state.entered[k];
        });
      var rec = ready ? recommend() : null;
      return rec ? rec.code : null;
    }
    function renderGallery() {
      if (!galleryEl) return;
      var sh = shape();
      if (!sh.sizes || !sh.sizes.length) {
        galleryEl.hidden = true;
        return;
      }
      galleryEl.hidden = false;
      galleryIntro.textContent = 'Every photo is the same ' + sh.name + ' — pick a size to see how it looks worn.';

      var recCode = galleryRecommended();
      var shown = gallerySize || recCode || sh.sizes[0];

      // size chips
      gallerySizes.innerHTML = '';
      sh.sizes.forEach(function (code) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sg-gallery-size';
        b.setAttribute('aria-pressed', code === shown ? 'true' : 'false');
        b.textContent = 'Size ' + shortSize(code, (sh.chart[code] || {}).display);
        b.addEventListener('click', function () {
          gallerySize = code;
          renderGallery();
        });
        gallerySizes.appendChild(b);
      });

      // gallery images
      var label = shortSize(shown, (sh.chart[shown] || {}).display);
      var imgs = (sh.gallery && sh.gallery[shown]) || [];
      if (typeof imgs === 'string') imgs = imgs ? [imgs] : []; // tolerate legacy single-string data
      if (imgs.length) {
        galleryFigure.classList.remove('is-empty');
        galleryFigure.innerHTML = imgs
          .map(function (src, i) {
            var count = imgs.length > 1 ? ' (' + (i + 1) + ' of ' + imgs.length + ')' : '';
            return (
              '<div class="sg-gallery-slide"><img src="' +
              src +
              '" alt="' +
              sh.name +
              ', size ' +
              label +
              count +
              '" loading="lazy"></div>'
            );
          })
          .join('');
      } else {
        galleryFigure.classList.add('is-empty');
        galleryFigure.innerHTML =
          '<div class="sg-gallery-slide sg-gallery-empty">' + sh.name + ' · size ' + label + '</div>';
      }
      var multi = imgs.length > 1;
      galleryFigure.classList.toggle('is-swipeable', multi);
      galleryFigure.scrollLeft = 0;

      if (galleryPrev) {
        galleryPrev.hidden = !multi;
        galleryPrev.disabled = true;
      }
      if (galleryNext) {
        galleryNext.hidden = !multi;
        galleryNext.disabled = !multi;
      }

      // dots (only when >1 image)
      galleryDots.innerHTML = '';
      if (multi) {
        galleryDots.hidden = false;
        imgs.forEach(function (src, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'sg-gallery-dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + imgs.length);
          d.addEventListener('click', function () {
            var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            galleryFigure.scrollTo({ left: i * galleryFigure.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
          });
          galleryDots.appendChild(d);
        });
      } else {
        galleryDots.hidden = true;
      }

      galleryKicker.textContent = sh.name + ' · size ' + label;
      // per-size model caption (each size has its own model); fall back to the section-wide default
      var sizeCaption = (sh.galleryCaptions && sh.galleryCaptions[shown]) || GALLERY_CAPTION;
      galleryCaption.textContent = sizeCaption + ' · wearing ' + label;

      // shop links
      var url = (sh.chart[shown] || {}).url;
      if (url) {
        galleryShop.style.display = '';
        galleryShop.href = url;
        galleryShop.textContent = 'Shop size ' + label;
      } else {
        galleryShop.style.display = 'none';
      }

      // "back to my size" only when a recommendation exists
      if (recCode) {
        galleryReset.hidden = false;
        galleryReset.disabled = shown === recCode;
      } else {
        galleryReset.hidden = true;
      }
    }

    // ---- render: result ----
    function renderResult() {
      var rec = recommend();
      var descEl = $('[data-sg-size-desc]');
      var sizeEl = $('[data-sg-size]');
      var shopEl = $('[data-sg-shop]');
      var nudgeEl = $('[data-sg-nudge]');
      var s = shape();
      var descriptor = s.descriptor ? s.descriptor : s.name;
      if (!rec) {
        sizeEl.textContent = '—';
        descEl.textContent = descriptor;
        nudgeEl.innerHTML =
          'Your measurements are beyond our standard range. <a href="https://svahausa.com/pages/contact-us">Reach out</a> and we’ll assist you!';
        shopEl.style.display = 'none';
      } else {
        var row = rec.row;
        sizeEl.textContent = shortSize(rec.code, row.display);
        descEl.textContent = descriptor;
        var slack = state.unit === 'cm' ? Math.round(rec.slack * CM * 10) / 10 : Math.round(rec.slack * 10) / 10;
        var tightLabel = MEAS[rec.tightest] ? MEAS[rec.tightest].label.toLowerCase() : rec.tightest;
        // room is measured from the midpoint of the stretch range; a negative gap means the
        // pick sits snug (the fabric stretches to fit) rather than having loose room.
        nudgeEl.textContent =
          slack < 0
            ? 'Sits snug at the ' + tightLabel + ' — the fabric stretches to fit.'
            : 'Comfortable at the ' + tightLabel + ' with about ' + slack + ' ' + state.unit + ' of room.';
        if (row.url) {
          shopEl.style.display = '';
          shopEl.href = row.url;
          shopEl.textContent = 'Shop ' + shortSize(rec.code, row.display);
        } else {
          shopEl.style.display = 'none';
        }
      }
      // "what you told us"
      var told = $('[data-sg-told]');
      told.innerHTML = '';
      var shapeRow = document.createElement('div');
      shapeRow.className = 'sg-told-row';
      shapeRow.innerHTML =
        '<span class="sg-told-label">Shape</span><span class="sg-told-val"><span class="sg-told-num">' +
        s.name +
        '</span><button type="button" class="sg-edit" data-sg-edit-shape>Edit</button></span>';
      told.appendChild(shapeRow);
      s.asks.forEach(function (key, i) {
        var meta = MEAS[key];
        var r = document.createElement('div');
        r.className = 'sg-told-row';
        r.innerHTML =
          '<span class="sg-told-label">' +
          meta.label +
          '</span><span class="sg-told-val"><span class="sg-told-num">' +
          toDisplay(state.values[key]) +
          (state.unit === 'cm' ? ' cm' : '"') +
          '</span><button type="button" class="sg-edit" data-sg-edit="' +
          i +
          '">Edit</button></span>';
        told.appendChild(r);
      });
      told.querySelectorAll('[data-sg-edit]').forEach(function (b) {
        b.addEventListener('click', function () {
          goMeasure(parseInt(b.getAttribute('data-sg-edit'), 10));
        });
      });
      var es = told.querySelector('[data-sg-edit-shape]');
      if (es) es.addEventListener('click', goShape);
      renderSwitcher();
      renderChart();
      renderGallery();
    }

    // ---- unit ----
    function setUnit(u) {
      state.unit = u;
      root.querySelectorAll('[data-sg-unit]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-sg-unit') === u ? 'true' : 'false');
      });
      try {
        window.dispatchEvent(new CustomEvent(UNIT_EVENT, { detail: { unit: u } }));
      } catch (e) {}
      if (typeof state.step === 'number') renderMeasure();
      if (state.done) renderResult();
      renderChart();
    }

    // ---- wire events ----
    root.querySelectorAll('[data-sg-unit]').forEach(function (b) {
      b.addEventListener('click', function () {
        setUnit(b.getAttribute('data-sg-unit'));
      });
    });
    galleryReset.addEventListener('click', function () {
      gallerySize = null; // back to the recommended size
      renderGallery();
    });
    $('[data-sg-dec]').addEventListener('click', function () {
      setValueInches(state.values[currentKey()] - 1);
    });
    $('[data-sg-inc]').addEventListener('click', function () {
      setValueInches(state.values[currentKey()] + 1);
    });
    $('[data-sg-range]').addEventListener('input', function (e) {
      setValueInches(Number(e.target.value));
    });
    // Typing is committed live, but a partial entry is ignored rather than clamped.
    // Clamping on every keystroke made the field unusable: the first digit of "42" was
    // rewritten to the minimum, so a multi-digit value could never be typed.
    var measureInput = $('[data-sg-input]');
    measureInput.addEventListener('input', function (e) {
      var v = parseFloat(e.target.value);
      if (isNaN(v)) return;
      var inches = fromDisplay(v);
      var meta = MEAS[currentKey()];
      if (inches < meta.min || inches > meta.max) return; // still mid-entry
      setValueInches(inches, true);
    });
    // Commit: clamp whatever they left in the field and repaint it.
    measureInput.addEventListener('change', function (e) {
      var v = parseFloat(e.target.value);
      if (isNaN(v)) paintInput();
      else setValueInches(fromDisplay(v));
    });
    measureInput.addEventListener('blur', function () {
      paintInput();
    });
    $('[data-sg-next]').addEventListener('click', function () {
      if (mIdx < shape().asks.length - 1) goMeasure(mIdx + 1);
      else goResult();
    });
    $('[data-sg-back]').addEventListener('click', function () {
      if (mIdx > 0) goMeasure(mIdx - 1);
      else goShape();
    });
    root.querySelectorAll('[data-sg-frac]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.fit = FRACTIONS[b.getAttribute('data-sg-frac')] || 0;
        root.querySelectorAll('[data-sg-frac]').forEach(function (o) {
          o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
        });
        renderResult();
      });
    });
    // "See how to measure ↓" in a wizard step -> open that row in Measure Yourself
    root.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-sg-see-measure]');
      if (link) {
        e.preventDefault();
        openMeasureFor(currentKey());
      }
    });

    // ---- drag-to-scroll ----
    function enableDragScroll(el) {
      if (!el) return;
      var down = false,
        startX = 0,
        startLeft = 0,
        moved = false;
      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        down = true;
        moved = false;
        startX = e.clientX;
        startLeft = el.scrollLeft;
        el.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        el.scrollLeft = startLeft - dx;
      });
      function end() {
        if (!down) return;
        down = false;
        el.classList.remove('is-dragging');
      }
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
      // swallow the click that ends a drag so it doesn't also pick a shape
      el.addEventListener(
        'click',
        function (e) {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true,
      );
      el.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    }

    // arrows auto-hide when there's no overflow and disable at each end
    function wireScrollArrows(scroller, prevBtn, nextBtn) {
      if (!scroller || !prevBtn || !nextBtn) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function page() {
        return Math.max(160, Math.round(scroller.clientWidth * 0.8));
      }
      function update() {
        var overflow = scroller.scrollWidth - scroller.clientWidth > 1;
        prevBtn.hidden = !overflow;
        nextBtn.hidden = !overflow;
        if (!overflow) return;
        var max = scroller.scrollWidth - scroller.clientWidth;
        prevBtn.disabled = scroller.scrollLeft <= 1;
        nextBtn.disabled = scroller.scrollLeft >= max - 1;
      }
      prevBtn.addEventListener('click', function () {
        scroller.scrollBy({ left: -page(), behavior: reduce ? 'auto' : 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        scroller.scrollBy({ left: page(), behavior: reduce ? 'auto' : 'smooth' });
      });
      var scheduled = false;
      scroller.addEventListener(
        'scroll',
        function () {
          if (scheduled) return;
          scheduled = true;
          window.requestAnimationFrame(function () {
            scheduled = false;
            update();
          });
        },
        { passive: true },
      );
      window.addEventListener('resize', update);
      update();
    }

    // ---- init ----
    renderShapes();
    renderSwitcher();
    renderMeasureYourself();
    renderChart();
    renderGallery();
    enableDragScroll(shapeTrack);
    enableDragScroll(switchChips);
    enableDragScroll(galleryFigure);
    wireScrollArrows(shapeTrack, $('[data-sg-scroll="-1"]'), $('[data-sg-scroll="1"]'));
    wireScrollArrows(switchChips, $('[data-sg-switch-arrow="-1"]'), $('[data-sg-switch-arrow="1"]'));
    if (switchEl) {
      var pinTop = 0;
      var measurePin = function () {
        pinTop = parseFloat(window.getComputedStyle(switchEl).top) || 0;
      };
      var syncPin = function () {
        if (switchEl.hidden) return;
        switchEl.classList.toggle('is-pinned', switchEl.getBoundingClientRect().top <= pinTop + 0.5);
      };
      var pinScheduled = false;
      var onPinScroll = function () {
        if (pinScheduled) return;
        pinScheduled = true;
        window.requestAnimationFrame(function () {
          pinScheduled = false;
          syncPin();
        });
      };
      measurePin();
      syncPin();
      window.addEventListener('scroll', onPinScroll, { passive: true });
      window.addEventListener('resize', function () {
        measurePin();
        syncPin();
      });
    }
    // arrow buttons page the portrait swiper one photo at a time
    root.querySelectorAll('[data-sg-gallery-arrow]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!galleryFigure) return;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var dir = Number(btn.getAttribute('data-sg-gallery-arrow'));
        galleryFigure.scrollBy({ left: dir * galleryFigure.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    // keep the active dot + arrow disabled-states in sync while the swiper scrolls
    if (galleryFigure) {
      galleryFigure.addEventListener('scroll', function () {
        var w = galleryFigure.clientWidth || 1;
        var count = galleryFigure.children.length;
        var idx = Math.round(galleryFigure.scrollLeft / w);
        if (galleryDots && !galleryDots.hidden) {
          var dots = galleryDots.children;
          for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === idx);
        }
        if (galleryPrev && !galleryPrev.hidden) galleryPrev.disabled = idx <= 0;
        if (galleryNext && !galleryNext.hidden) galleryNext.disabled = idx >= count - 1;
      });
    }
    goShape();
  }

  function boot() {
    document.querySelectorAll('[data-sg-root]').forEach(initSizeGuide);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
